import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class SaleDetailReportByHotel {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.pageIndex = data.pageIndex || PAGINATION.pageIndex;
        this.pageSize = data.pageSize || PAGINATION.pageSize;
        this.totalCount = data.totalCount || 0;
        this.totalPage = Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize));
        this.startDate = data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks');
        this.endDate = data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days');
        this.orderBy = data.orderBy;
        this.orderByDesc = data.orderByDesc;
        this.items = data.result && data.result.map(item => new SaleReportByHotelItem(item));
    }

}

export class SaleReportByHotelItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || ""
        this.orderId = data.orderId || ""
        this.orderCode = data.orderCode || ""
        this.createdDate = data.createdDate || ""
        this.checkInDate = data.checkInDate || ""
        this.checkOutDate = data.checkOutDate || ""
        this.hotelName = data.hotelName || ""
        this.ratePlanName = data.ratePlanName || ""
        this.ratePlanCode = data.ratePlanCode || ""
        this.promotionName = data.promotionName || ""
        this.roomType = data.roomType || ""
        this.lengthOfStay = data.lengthOfStay || 0
        this.adultQuantity = data.adultQuantity || 0
        this.childQuantity = data.childQuantity || 0
        this.nationality = data.nationality || ""
        this.priceRoom = data.priceRoom || 0
        this.markUpPriceRoom = data.markUpPriceRoom || 0
        this.salePrice = data.salePrice || 0
        this.couponValue = data.couponValue || 0
        this.surcharge = data.surcharge || 0
        this.surchargeDetail = data.surchargeDetail || 0
        this.totalAmount = data.totalAmount || 0
        this.couponCode = data.couponCode || ""
        this.memberShipCode = data.memberShipCode || ""
        this.transactionId = data.transactionId || ""
        this.paymentType = data.paymentType || ""
        this.bookingId = data.bookingId || ""
        this.saleChannel = data.saleChannel || ""
        this.channel = data.channel || ""
        this.fullnameCustomer = data.fullnameCustomer || ""
        this.phoneNumberCustomer = data.phoneNumberCustomer || ""
        this.emailCustomer = data.emailCustomer || ""
        this.fullname = data.fullname || ""
        this.phoneNumber = data.phoneNumber || ""
        this.email = data.email || ""
        this.agentId = data.agentId || ""
        this.note = data.note || ""
    }
}
